export default __webpack_public_path__ + "static/media/Bell.53d0e620.mp3";